import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';

import { FeatureFlagService, SettingService } from '@nha/api/core';

export function loadSettings(featureFlagService: FeatureFlagService, settingService: SettingService) {
	return async (): Promise<void> => {
		await Promise.all([featureFlagService.loadFeatureFlags(), settingService.loadFrontendSettings()]);
	};
}

export const AppSettingsInitializer: EnvironmentProviders = provideAppInitializer(() => {
	const initializerFn = loadSettings(inject(FeatureFlagService), inject(SettingService));
	return initializerFn();
});
